// filterView/variants/builderView.js — variant B "Baukasten" of the documents.php filter views (plan
// documents_admin-search, phase filter-varianten): the sentence "Zeige Dokumente, die [alle | mindestens eine] der
// folgenden Bedingungen erfüllen:", one row per condition (a field may repeat), "+ Bedingung hinzufügen".
//
// The rows (parts/conditionRows.js) are reconciled by condition id on every store change, so typing keeps focus.
// Buttons OK / reset / info belong to the tabs, not to the variant.
//
// createBuilderView({ schema, store, options: { addField } }) → { element, destroy }
//   addField: field of a new row (default: the first text field that is not the search bar)

import { createDisposers } from '../../core/disposers.js';
import { validate } from '../conditionSet.js';
import { createConditionRows } from '../parts/conditionRows.js';
import { createCombineSentence } from '../parts/combineToggle.js';

// The field a new row starts with: the first text field that is not the search bar (shared with the search bar view).
export function defaultAddField(schema) {
    return (schema.fields.find((f) => f.kind === 'text' && f.quick !== 'search') ?? schema.fields[0]).key;
}

export function createBuilderView({ schema, store, options = {} }) {
    const disposers = createDisposers();
    const texts = schema.texts;

    const element = document.createElement('div');
    element.className = 'topo2-filterview topo2-filterview--builder';

    const lead = createCombineSentence({ store, texts });
    disposers.add(() => lead.destroy());
    const rows = createConditionRows({ schema, store, addField: options.addField ?? defaultAddField(schema) });
    disposers.add(() => rows.destroy());
    element.append(lead.element, rows.element);

    const render = (set) => {
        lead.update(set.combine);
        rows.render(set.conditions, new Map(validate(set, schema).map((p) => [p.id, p.reason])));
    };

    disposers.add(store.subscribe(render));
    render(store.get());

    return {
        element,
        destroy() {
            disposers.dispose();
        },
    };
}
